import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { GenerativeAIServiceTick } from "../../../app-constants";

function Discoverportal() {
  return (
    <section
      className="discover_portal p-100"
      style={{ background: "#FAFAFA" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Discover the <span>Perfect B2B Portal</span> for Your Business
              Model
            </h2>
            <p>
              At TekRevol, we build high-performing B2B portals designed to meet
              specific business models and industry demands. Whether you’re
              enhancing supply chain efficiency or optimizing customer
              management, our B2B portal development services offer performance,
              scalability, and user engagement.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="discover-portal-box">
              <div className="discover-portal-icon">
                {GenerativeAIServiceTick}
              </div>
              <div className="discover-portal-content">
                <h5>B2B eCommerce Portal</h5>
                <p>
                  Designed for streamlined wholesale transactions, our B2B
                  eCommerce portals handle RFQs, dynamic pricing, and automated
                  order fulfillment processes.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="discover-portal-box">
              <div className="discover-portal-icon">
                {GenerativeAIServiceTick}
              </div>
              <div className="discover-portal-content">
                <h5>B2B Vendor Portal</h5>
                <p>
                  We develop vendor portals with e-procurement capabilities,
                  including supplier onboarding, automated POs, bidding systems,
                  and secure invoicing.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="discover-portal-box">
              <div className="discover-portal-icon">
                {GenerativeAIServiceTick}
              </div>
              <div className="discover-portal-content">
                <h5>B2B Customer Portal</h5>
                <p>
                  Our customer portals allow clients to access services, submit
                  orders, track deliveries, and request support from a unified
                  dashboard.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="discover-portal-box">
              <div className="discover-portal-icon">
                {GenerativeAIServiceTick}
              </div>
              <div className="discover-portal-content">
                <h5>B2B Partner Portal</h5>
                <p>
                  Enable partners to access sales tools, technical resources,
                  and collaboration features for streamlined partner
                  relationship management.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-xl-0 mb-4">
            <div className="discover-portal-box">
              <div className="discover-portal-icon">
                {GenerativeAIServiceTick}
              </div>
              <div className="discover-portal-content">
                <h5>B2B Marketplace Portal</h5>
                <p>
                  We create multi-vendor platforms for seamless vendor
                  management, where businesses can manage products, orders, and
                  customer interactions.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-xl-0 mb-4">
            <div className="discover-portal-box">
              <div className="discover-portal-icon">
                {GenerativeAIServiceTick}
              </div>
              <div className="discover-portal-content">
                <h5>B2B Aggregator Portal</h5>
                <p>
                  Ideal for aggregating third-party offerings, this portal
                  centralizes vendor products or services into a single, easily
                  navigable platform.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-md-0 mb-4">
            <div className="discover-portal-box">
              <div className="discover-portal-icon">
                {GenerativeAIServiceTick}
              </div>
              <div className="discover-portal-content">
                <h5>B2B Self-Service Portal</h5>
                <p>
                  Developed to empower users with self-service capabilities,
                  allowing clients to independently manage accounts,
                  subscriptions, and service requests.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="discover-portal-box">
              <div className="discover-portal-icon">
                {GenerativeAIServiceTick}
              </div>
              <div className="discover-portal-content">
                <h5>B2B Collaboration Portal</h5>
                <p>
                  Built for project-centric businesses, these portals facilitate
                  document sharing, team collaboration, and secure
                  communications across partners.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Discoverportal;
